import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import "../../../../styles/AppCss.css";
import { useParams, useSearchParams } from "react-router-dom";
import { getDetalleFacturaObsequio, getDetalleObsequio, getLocalesFiltrarRuc, postAddObsequio, postAprobarFacturaObsequio, postConfirmarCanjeObsequio, postRechazarFacturaObsequio, postUpdateObsequio, putFacturaObsequio } from "../../../../api/ApiService";
import AddObsequiosComponents from "./components/AddObsequiosComponents";



function FacturaObsequioDetallePage() {
    const [cargando, setCargando] = useState(false);
    const [titulo, setTitulo] = useState("");
    const [descripcion, setDescripcion] = useState('');
    const [imagen, setImagen] = useState("");
    const [imagenFormData, setImagenFormData] = useState(null);
    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaFin, setFechaFin] = useState("");
    const [montoMinimo, setMontoMinimo] = useState("");
    const [stockTotal, setStockTotal] = useState("");
    const [limitePorUsuario, setLimitePorUsuario] = useState("");
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loadingGuardar, setLoadingGuardar] = useState(false);


    const [imagenFactura, setImagenFactura] = useState("");
    const [fechaFactura, setFechaFactura] = useState("");
    const [montoTotal, setMontoTotal] = useState("");
    const [nroFactura, setNroFactura] = useState("");
    const [timbrado, setTimbrado] = useState("");
    const [localId, setLocalId] = useState("");

    const [motivoRechazo, setMotivoRechazo] = useState("");

    const [dataObsequio, setDataObsequio] = useState({});

    const [locales, setLocales] = useState([]);
    const [localesSearch, setLocalesSearch] = useState('');
    const [localesSelected, setLocalesSelected] = useState(null);
    const [loadingCargarLocales, setLoadingCargarLocales] = useState(false);









    const stateToken = useSelector((state) => state.reducerGlobal.token);

    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get("mode");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (!stateToken) {
            return;
        }

        if (id) {
            handleDetalleObsequioApi();
        } else {
            setCargando(true);
        }
    }, [id, stateToken]);

    //=================================================================================================funcion para listar las categorias
    const handleListarLocales = (busqueda) => {

        getLocalesFiltrarRuc(busqueda, stateToken?.access_token)
            .then((response) => {
                console.log("response-getLocalesFiltrarRuc", response);
                if (response?.length > 0) {
                    setLocales(response);
                } else {
                    setLocales([]);
                }
                setLoadingCargarLocales(false);
            })
            .catch((error) => {
                console.log("error-getLocalesFiltrarRuc", error);
                setLoadingCargarLocales(false);
                setLocales([]);
            });
    };

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (localesSearch.length > 2) {
                setLoadingCargarLocales(true);
                handleListarLocales(localesSearch);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, localesSearch]);




    //=========================================================funcion para buscar local
    const handleSearchLocal = (value) => {
        console.log("value-handleSearchCategoria: ", value);
        setLocalesSearch(value);
    };


    //=========================================================funcion para seleccionar local
    const handleLocalSelected = (value) => {
        console.log("value-handleCategoriaSelected: ", value);
        setLocalesSelected(value);
    };




    //========================================================= funcion para cerrar la alerta
    const handleClose = () => {
        setOpen(false);
    };

    //========================================================= funcion para cancelar y volver a la lista
    const handleCancelar = () => {
        window.history.back();
    };

    //========================================================= funcion para obtener el detalle de un obsequio
    const handleDetalleObsequioApi = () => {
        getDetalleFacturaObsequio(stateToken?.access_token, id)
            .then((response) => {
                // console.log("response==>getDetalleFacturaObsequio", response);
                const detalle = response?.data || response || {};

                setCargando(true);

                setDataObsequio(detalle);
                //"fecha_factura": "2026-02-05T00:00:00.000000Z", formatear a "2026-02-05"
                // setFechaFactura(detalle?.fecha_factura || "");
                if (detalle?.fecha_factura) {
                    const fecha = new Date(detalle.fecha_factura);
                    const fechaFormateada = fecha.toISOString().split('T')[0];
                    setFechaFactura(fechaFormateada);
                } else {
                    setFechaFactura("");
                }
                setMontoTotal(detalle?.monto_total || "");
                setNroFactura(detalle?.nro_factura || "");
                setTimbrado(detalle?.timbrado || "");
                setLocalId(detalle?.local_id || "");
                setImagenFactura(detalle?.imagen_url || "");

                if (detalle?.local) {
                    setLocalesSelected({
                        id: detalle?.local?.id,
                        razon_social: detalle?.local?.razon_social,
                        ruc: detalle?.local?.ruc,
                        nombre_fantasia: detalle?.local?.nombre_fantasia,
                    });
                }
            })
            .catch(() => {
                setCargando(true);
                setOpen(true);
                setSeverity("error");
                setMensaje("Error al cargar los datos del obsequio");


            });
    };

    //========================================================= funcion para validar campos obligatorios
    const validateFields = () => {
        if (localesSelected === null) {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo local es obligatorio");
            return false;
        }
        if (nroFactura.trim() === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo nro de factura es obligatorio");
            return false;
        }

        if (timbrado.trim() === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo timbrado es obligatorio");
            return false;
        }
        if (fechaFactura === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo fecha factura es obligatorio");
            return false;
        }
        if (montoTotal.trim() === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo monto total es obligatorio");
            return false;
        }

        return true;
    };

    //========================================================= funcion para construir el formData del formulario
    const buildBody = () => {
        const formData = new FormData();
        formData.append("titulo", titulo);
        formData.append("descripcion", descripcion);
        formData.append("fecha_inicio", fechaInicio);
        formData.append("fecha_fin", fechaFin);
        formData.append("monto_minimo", montoMinimo);
        formData.append("stock_total", stockTotal);
        formData.append("limite_por_usuario", limitePorUsuario);

        // Solo enviamos la imagen cuando hay un archivo seleccionado
        if (imagenFormData) {
            formData.append("imagen", imagenFormData);
        }

        return formData;
    };





    //tercera llamada
    //========================================================= funcion para confirmar canje de obsequio
    const handleConfirmarCanjeObsequio = (body) => {
        postConfirmarCanjeObsequio(stateToken?.access_token, body, id)
            .then(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("success");
                setMensaje("Obsequio aprobado con exito");

            })
            .catch((err) => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("error");
                setMensaje(err?.message || "Error al confirmar el canje del obsequio");
            });
    };




    //segunda llamada
    //========================================================= funcion para aprobar factura de obsequio
    const handleAprobarFacturaObsequioApi = (body) => {
        postAprobarFacturaObsequio(stateToken?.access_token, body, id)
            .then(() => {
                handleConfirmarCanjeObsequio(body);
            })
            .catch((err) => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("error");
                setMensaje(err?.message || "Error al aprobar el obsequio");
            });
    };







    //primera llamada
    //========================================================= funcion para revisar obsequio
    const handleRevisarObsequioApi = (body) => {
        putFacturaObsequio(stateToken?.access_token, body, id)
            .then(() => {

                handleAprobarFacturaObsequioApi(body);
            })
            .catch(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("error");
                setMensaje("Error al revisar el obsequio");
            });
    };






    //========================================================= funcion para guardar un nuevo obsequio
    const handleGuardar = () => {
        if (!validateFields()) {
            return;
        }


        let body = {
            fecha_factura: fechaFactura,
            monto_total: parseFloat(montoTotal),
            nro_factura: nroFactura,
            timbrado: timbrado,
            ruc: localesSelected?.ruc || "",
            local_id: localesSelected?.id || ""
        };
        // console.log("body-buildBody", body);



        setLoadingGuardar(true);
        handleRevisarObsequioApi(body);
    };







    //primera llamada
    //========================================================= funcion para revisar obsequio
    const handleApiRechazar = (body) => {
        postRechazarFacturaObsequio(stateToken?.access_token, body, id)
            .then(() => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("success");
                setMensaje("Factura del obsequio rechazada con exito");

                handleDetalleObsequioApi();

            })
            .catch((err) => {
                console.log("err-postRechazarFacturaObsequio", err);
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity("error");
                setMensaje(err?.message || "Error al rechazar la factura del obsequio");
            });
    };


    //========================================================= funcion para rechazar un obsequio
    const handleRechazarFactura = () => {
        if (motivoRechazo.trim() === "") {
            setOpen(true);
            setSeverity("warning");
            setMensaje("El campo motivo de rechazo es obligatorio");
            return;
        }


        let body = {
            motivo_rechazo: motivoRechazo,
        };
        // console.log("body-buildBody", body);



        setLoadingGuardar(true);
        handleApiRechazar(body);
    };






    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="mx-auto max-w-6xl">
                    <div className="mb-6">
                        <h1 className="mb-1 text-2xl font-bold text-gray-800">
                            {id ? (mode === "view" ? "Detalle Factura" : "Actualizar Factura") : ""}
                        </h1>
                        <p className="text-sm text-gray-500">
                            {id ? (mode === "view" ? "Visualiza la informacion de la factura." : "Actualiza la informacion principal de la factura.") : ""}
                        </p>
                    </div>

                    {cargando ? (
                        <AddObsequiosComponents
                            id={id}
                            mode={mode}

                            dataObsequio={dataObsequio}

                            motivoRechazo={motivoRechazo}
                            setMotivoRechazo={setMotivoRechazo}

                            dataLocales={locales}
                            loadingCargarLocales={loadingCargarLocales}
                            localesSelected={localesSelected}
                            handleLocalSelected={handleLocalSelected}
                            handleSearchLocal={handleSearchLocal}



                            imagenFactura={imagenFactura}

                            fechaFactura={fechaFactura}
                            setFechaFactura={setFechaFactura}

                            montoTotal={montoTotal}
                            setMontoTotal={setMontoTotal}

                            nroFactura={nroFactura}
                            setNroFactura={setNroFactura}

                            timbrado={timbrado}
                            setTimbrado={setTimbrado}



                            localId={localId}



                            loadingGuardar={loadingGuardar}




                            handleRechazarFactura={handleRechazarFactura}
                            handleGuardar={handleGuardar}
                            handleCancelar={handleCancelar}
                        />
                    ) : (
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default FacturaObsequioDetallePage;